import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-white pt-16 pb-8" data-id="element-17">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-18">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-19">
          {/* Brand Column */}
          <div className="col-span-1 md:col-span-1" data-id="element-20">
            <img className="h-24 w-auto mb-6" src="https://cdn.magicpatterns.com/uploads/jbELFVU6yimTHPdBB4r5GJ/175975597_padded_logo.png" alt="Precision Pro Sprayers" data-id="element-21" />
            <p className="text-gray-400 text-sm leading-relaxed" data-id="element-22">
              Professional grade electric sprayers built for contractors who
              need reliability and speed.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-23">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-24">
              Products
            </h3>
            <ul className="space-y-3" data-id="element-25">
              <li data-id="element-26">
                <Link to="/products/forcex-complete" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-27">
                  ForceX Complete Kit
                </Link>
              </li>
              <li data-id="element-28">
                <Link to="/products/forcex-diy" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-29">
                  ForceX DIY Kit
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-30">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-31">
              Company
            </h3>
            <ul className="space-y-3" data-id="element-32">
              <li data-id="element-33">
                <Link to="/about" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-34">
                  About Us
                </Link>
              </li>
              <li data-id="element-35">
                <Link to="/warranty" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-36">
                  Warranty & Returns
                </Link>
              </li>
              <li data-id="element-37">
                <Link to="/contact" className="text-gray-300 hover:text-brand-yellow transition-colors" data-id="element-38">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div data-id="element-39">
            <h3 className="text-brand-yellow font-bold uppercase tracking-wider mb-4" data-id="element-40">
              Contact
            </h3>
            <ul className="space-y-4" data-id="element-41">
              <li className="flex items-start" data-id="element-42">
                <Phone className="h-5 w-5 text-brand-yellow mr-3 mt-0.5" data-id="element-43" />
                <span className="text-gray-300" data-id="element-44">810-818-5941</span>
              </li>
              <li className="flex items-start" data-id="element-45">
                <Mail className="h-5 w-5 text-brand-yellow mr-3 mt-0.5" data-id="element-46" />
                <span className="text-gray-300" data-id="element-47">
                  brandon@precisionprosprayers.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-48">
          <p className="text-gray-500 text-sm" data-id="element-49">
            © {new Date().getFullYear()} Precision Pro Sprayers. All rights
            reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-50">
            <Link to="/warranty" className="text-gray-500 text-sm hover:text-brand-yellow" data-id="element-51">
              Privacy Policy
            </Link>
            <Link to="/warranty" className="text-gray-500 text-sm hover:text-brand-yellow" data-id="element-52">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}